import React from 'react';
import _ from "underscore";

const Address = function(props) {
    const childBlocks = _.values(props.blocks || {}).map((Block, id) => <Block.component context={props.context} key={id}/>);

    if (childBlocks.length > 0) {
        return (
            <category name='Address' id='address' iconclass='category with-icon-paths snap-icon-location_dual'>
                <label text="Address"/>
                { childBlocks }
            </category>
        );
    }

    return null;
}

export default Address;
